import React from "react";
import { motion } from "framer-motion";
import { Flame, Dumbbell, Zap, HeartPulse } from "lucide-react";
import PhoneMockup from "./PhoneMockup";
import { SCREEN_GOALS } from "../../lib/assets";

const GOALS = [
    {
        icon: Flame,
        title: "Emagrecer",
        desc: "Reduz calorias, açúcar e gordura no seu dia a dia.",
    },
    {
        icon: Dumbbell,
        title: "Ganhar massa",
        desc: "Prioriza proteína e calorias de qualidade.",
    },
    {
        icon: Zap,
        title: "Ter mais energia",
        desc: "Carboidratos de qualidade, menos picos de açúcar.",
    },
    {
        icon: HeartPulse,
        title: "Cuidar da saúde",
        desc: "Alimentos in natura, longe dos ultraprocessados.",
    },
];

export default function MinhaMeta() {
    return (
        <section
            id="minha-meta"
            data-testid="minha-meta-section"
            className="relative py-20 md:py-28 bg-[#F8FAFC]"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                    <motion.div
                        className="lg:col-span-7 order-2 lg:order-1"
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.6 }}
                    >
                        <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#16A34A]">
                            Minha Meta
                        </span>
                        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0B1C3A] tracking-tight">
                            Não basta saber se é bom. Tem que saber se é bom{" "}
                            <span className="text-[#16A34A]">para você</span>.
                        </h2>
                        <p className="mt-5 text-lg text-[#475569] leading-relaxed max-w-xl">
                            Escolha seu objetivo e o Dentro mostra, produto a
                            produto, se ele ajuda ou atrapalha a sua rotina.
                        </p>

                        <div className="mt-8 grid sm:grid-cols-2 gap-4">
                            {GOALS.map((g, i) => {
                                const Icon = g.icon;
                                return (
                                    <motion.div
                                        key={g.title}
                                        initial={{ opacity: 0, y: 16 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{
                                            once: true,
                                            margin: "-80px",
                                        }}
                                        transition={{
                                            duration: 0.5,
                                            delay: i * 0.06,
                                        }}
                                        data-testid={`goal-card-${g.title.toLowerCase().replace(/\s+/g, "-")}`}
                                        className="bg-white rounded-2xl p-5 border border-slate-100 hover:border-[#16A34A]/40 hover:shadow-[0_14px_40px_rgba(22,163,74,0.08)] transition-all group"
                                    >
                                        <div className="h-11 w-11 rounded-xl bg-[#16A34A]/10 grid place-items-center text-[#16A34A] group-hover:bg-[#16A34A] group-hover:text-white transition-colors">
                                            <Icon size={20} strokeWidth={2.25} />
                                        </div>
                                        <h3 className="mt-4 font-display text-lg font-extrabold text-[#0B1C3A]">
                                            {g.title}
                                        </h3>
                                        <p className="mt-1 text-sm text-[#475569] leading-relaxed">
                                            {g.desc}
                                        </p>
                                    </motion.div>
                                );
                            })}
                        </div>
                    </motion.div>

                    <motion.div
                        className="lg:col-span-5 order-1 lg:order-2 flex justify-center lg:justify-end"
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                    >
                        <PhoneMockup data-testid="minha-meta-phone">
                            <img
                                src={SCREEN_GOALS}
                                alt="Tela do app Dentro — escolhendo o objetivo"
                            />
                        </PhoneMockup>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
